exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/OTHERS/FirstmediaShowSchedule/src/app/show-newspaper/show-newspaper.component.css
// module id = ../../../../../src/app/show-newspaper/show-newspaper.component.css
// module chunks = main